import { BaseViewModel } from "./base.viewmodel";

export class ServiceViewModel implements BaseViewModel {
    PageTitle: string = 'Service';
}
    

